import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SmButton from '@/components/ui/buttons/SmButton/SmButton.vue'
import SmIcon from '@/components/ui/SmIcon/SmIcon.vue'

import '@/components/ui/SmUpButton/style.scss'


export default /*#__PURE__*/_defineComponent({
  __name: 'SmUpButton',
  setup(__props) {

const clickHandler = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SmButton, {
    type: "secondary",
    class: "up-button",
    size: "auto",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (clickHandler()))
  }, {
    default: _withCtx(() => [
      _createVNode(SmIcon, { name: "chevronUp" })
    ]),
    _: 1
  }))
}
}

})